import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-app-style-one',
  templateUrl: './download-app-style-one.component.html',
  styleUrls: ['./download-app-style-one.component.scss']
})
export class DownloadAppStyleOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
